import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

export class StockLocationListingMinimal extends Component {
    constructor(props) {
        super(props);
    };

    render() {
        var badgetype = "badge bg-success"
        if (this.props.stockData.quantity <= 0) {
            badgetype = "badge bg-danger"
        }

        // Prepare barcode hint based on provided barcodes
        let barcodeHint = null;
        if (this.props.barcodesLoading) {
            barcodeHint = <span class="text-muted">...</span>;
        }
        else if (this.props.barcodes && this.props.barcodes.length > 0) {
            const first = this.props.barcodes[0];
            const hasMany = this.props.barcodes.length > 1;
            barcodeHint = <span class="text-muted"> {hasMany ? ` E.g. ${first} ...` : ` ${first}`}</span>;
        }

        return (
            < li class="d-flex justify-content-between align-items-center">
                <small>
                  <b>{this.props.stockData.location.barcode}</b> - {this.props.stockData.location.identifier} [{this.props.stockData.store.name}] {barcodeHint}
                </small>
                <span class={badgetype}>{this.props.stockData.quantity}</span>
            </li>
        );
    }
}